/**
 * Phase 86 Plan 86-04 Task 2 — rewritten as the Compost design's right-pane
 * page header (`.planning/design/mytasks-compost/README.md`, "Right pane —
 * page header"). Supersedes the Phase 45 45-06 header: the generated
 * sentence replaces the old eyebrow + "My Tasks" title + count badge, and
 * the search field moved to `MyTasksTopBar`.
 *
 * `sentence` is computed by the page from `frontend/src/utils/myTasksCompost.ts`
 * (`generateHeaderSentence`) — this component only renders it.
 */
import { MICRO_LABEL_GREY_HEX } from './compostTokens';

const KEYBOARD_HINTS = ['j / k move', 'T touch', '↵ open'] as const;

export interface MyTasksHeaderProps {
  /** The generated Compost sentence — see `myTasksCompost.generateHeaderSentence`. */
  sentence: string;
  /** Sub-line under the sentence; defaults to the locked rot-sort copy. */
  subLine?: string;
}

export function MyTasksHeader({
  sentence,
  subLine = 'sorted by rot · oldest activity at the bottom, where the flies are',
}: MyTasksHeaderProps) {
  return (
    <div
      data-testid="my-tasks-header"
      className="flex items-end gap-3 px-[18px] pt-4 pb-[13px] border-b border-ms-border bg-ms-surface shrink-0"
    >
      <div>
        <h1 className="mb-[3px] text-[19px] font-semibold tracking-[-.02em] text-ms-text-strong">
          {sentence}
        </h1>
        <div className="font-mono text-[11px]" style={{ color: MICRO_LABEL_GREY_HEX }}>
          {subLine}
        </div>
      </div>
      <div className="ml-auto flex gap-1.5">
        {KEYBOARD_HINTS.map((hint) => (
          <span
            key={hint}
            className="px-[9px] py-[5px] rounded border border-ms-border bg-ms-surface font-mono text-[10.5px] font-medium"
            style={{ color: MICRO_LABEL_GREY_HEX }}
          >
            {hint}
          </span>
        ))}
      </div>
    </div>
  );
}
